module.exports = __webpack_public_path__ + "static/media/discord.238a607e.svg";